import React, { createContext, useContext, useState, ReactNode } from "react";

interface AppContextType {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  voteFilter: "like" | "meh" | "dislike" | "approve" | null;
  setVoteFilter: (filter: "like" | "meh" | "dislike" | "approve" | null) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [voteFilter, setVoteFilter] = useState<
    "like" | "meh" | "dislike" | "approve" | null
  >(null);

  return (
    <AppContext.Provider value={{ searchTerm, setSearchTerm, voteFilter, setVoteFilter }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
